import { getUserId, getToken, getLoginId, getMemberUserId, getAccountId } from '@/services/methods/user'
import { RequestConfig } from '@/services/http/types'
import { useGlobalStore } from '@/stores'
import service from '@/services'
import http from '@/services/http'

const globalStore = useGlobalStore()

/**
 * 账户登录
 */
export function wsLogin(data: Proto.LoginReq) {
    return http.mqRequest<Proto.LoginRsp>({
        data,
        requestCode: 'LoginReq',
        responseCode: 'LoginRsp'
    })
}

/**
 * 账户登录
 */
export function httpLogin(config: RequestConfig<Model.LoginReq> = {}) {
    return http.goRequest<Model.LoginRsp>({
        method: 'post',
        url: '/Account/Login',
        data: config.data,
    })
}

/**
 * 用户登出
 */
export function logout(config: RequestConfig = {}) {
    return http.goRequest<Model.LoginRsp>({
        url: '/Account/Loginout',
        params: config.data,
    })
}

/**
 * Token校验
 */
export function tokenCheck() {
    if (globalStore.getSystemInfo('tradeChannel') === 'ws') {
        return http.mqRequest<Proto.TokenCheckRsp>({
            data: <Proto.TokenCheckReq>{
                LoginID: getLoginId(),
                Token: getToken()
            },
            requestCode: 'TokenCheckReq',
            responseCode: 'TokenCheckRsp'
        })
    }
    return http.goRequest({
        url: '/Account/TokenCheck'
    })
}

/**
 * 查询账户菜单
 */
export function queryAccountMenu(config: RequestConfig = {}) {
    return http.request<Model.UserRoutes[]>({
        url: './config/router.json',
        params: config.data,
    })
}

/**
 * 查询登录ID
 */
export function queryLoginId(config: RequestConfig<{ username: string }> = {}) {
    return http.commonRequest<string>({
        url: '/User/GetLoginID',
        params: config.data,
    }, 'GetLoginID')
}

/**
 * 查询登录账户配置信息
 */
export function queryLoginData(config: RequestConfig<Model.LoginQueryReq> = {}) {
    return http.commonRequest<Model.LoginQueryRsp>({
        url: '/User/LoginQuery',
        params: config.data,
    }, 'LoginQuery')
}

/**
 * 获取用户账号信息
 */
export function queryUserAccount(config: RequestConfig<{ userID: number }> = {}) {
    return http.commonRequest<Model.UserAccount>({
        url: '/User/GetUserAccount',
        params: {
            userID: getUserId(),
            ...config.data
        },
    }, 'GetUserAccount')
}

/**
 * 获取资金账户今日配置信息
 */
export function getTodayAccountConfigInfo(config: RequestConfig<Model.TodayAccountConfigInfoReq> = {}) {
    return http.commonRequest<Model.TodayAccountConfigInfoRsp>({
        url: '/User/GetTodayAccountConfigInfo',
        params: {
            accountid: getAccountId(),
            ...config.data
        },
    })
}

/**
 * 查询资金账户信息
 */
export function queryTaAccounts(config: RequestConfig<Model.TaAccountsReq> = {}) {
    return http.commonRequest<Model.TaAccountsRsp[]>({
        url: '/TaAccount/GetTaAccounts',
        params: config.data,
    }, 'GetTaAccounts')
}

/**
 * 查询账户角色
 */
export function queryAccountRole(config: RequestConfig = {}) {
    return http.commonRequest<Model.UserRole[]>({
        url: '/account/role',
        params: config.data,
    })
}

/**
 * 查询实名认证信息
 */
export function queryWrDraftUserInfo(config: RequestConfig<Model.WrDraftUserInfoReq> = {}) {
    return http.commonRequest<Model.UserInfo[]>({
        url: '/WrTrade2/QueryWrDraftUserInfo',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 实名认证请求
 */
export function requestAddAuth(config: RequestConfig<Model.AddAuthReq> = {}) {
    return http.request<Model.AddAuthRsp>({
        method: 'post',
        url: service.getConfig('openApiUrl') + '/onlineopen/userInfo/addAuth',
        data: config.data,
    })
}

/**
 * 投资者销户申请
 */
export function investorDel(config: RequestConfig<Proto.InvestorDelReq>) {
    return http.mqRequest<Proto.InvestorDelRsp>({
        data: config.data,
        requestCode: 'InvestorDelReq',
        responseCode: 'InvestorDelRsp',
    })
}

/**
 * 修改密码
 */
export function modifyPassword(config: RequestConfig<Proto.ModifyPwdReq>) {
    return http.mqRequest<Proto.ModifyPwdRsp>({
        data: config.data,
        requestCode: 'ModifyPwdReq',
        responseCode: 'ModifyPwdRsp',
    })
}

/**
 * 实名认证添加用户
 */
export function requestAddUser(config: RequestConfig<Model.AddUserReq> = {}) {
    return http.goRequest<Model.AddUserRsp>({
        method: 'post',
        url: '/Account/AddUser',
        data: config.data,
    })
}

/**
 * 查询用户电子签记录表
 */
export function queryUserESignRecord(config: RequestConfig<Model.UserESignRecordReq> = {}) {
    return http.goRequest<Model.UserESignRecordRsq[]>({
        method: 'get',
        url: '/Account/QueryUserESignRecord',
        params: config.data,
    })
}

/**
 * 上传待签署文件和添加签署方
 */
export function requestCreateContractAndAddSigner(config: RequestConfig<Model.ContractAndAddSignerReq> = {}) {
    return http.goRequest<Model.ContractAndAddSignerRsq>({
        method: 'post',
        url: '/Account/CreateContractAndAddSigner',
        data: config.data,
    })
}

/**
 * 提交实名认证
 */
export function requestSignCompleted(config: RequestConfig<Model.ContractAndAddSignerReq> = {}) {
    return http.goRequest<Model.ContractAndAddSignerRsq>({
        method: 'post',
        url: '/Account/SignCompleted',
        data: config.data,
    })
}

/**
 * 个人意愿核身认证
 */
export function requestWillFace(config: RequestConfig<Model.WillFaceReq> = {}) {
    return http.goRequest<Model.WillFaceRsq>({
        method: 'post',
        url: '/Account/WillFace',
        data: config.data,
    })
}

/**
 * 个人意愿核身认证-爱签长连
 */
export function requestAsignWillFace(config: RequestConfig<Model.WillFaceReq> = {}) {
    return http.commonRequest<Model.WillFaceRsq>({
        method: 'post',
        url: '/Asign/WillFace',
        data: config.data,
    })
}

/**
 * 证件号重复校验
 */
export function requestCheckCardNum(config: RequestConfig<Model.CheckCardNumReq> = {}) {
    return http.request<Model.CheckCardNumRsp>({
        method: 'get',
        url: service.getConfig('openApiUrl') + '/onlineopen/userInfo/checkCardNum',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 查询用户电子签记录表
 */
export function queryTencentUsereSignRecords(config: RequestConfig<Model.TencentUsereSignRecordsReq> = {}) {
    return http.commonRequest<Model.TencentUsereSignRecordsRsq[]>({
        method: 'get',
        url: '/Tencent/QueryUsereSignRecords',
        params: {
            userId: getUserId(),
            memberUserId: getMemberUserId(),
            ...config.data
        },
    })
}

/**
 * 通过合同名和模板 id 直接发起签署流程
 */
export function requestCreateFlowByTemplateDirectly(config: RequestConfig<Model.CreateFlowByTemplateDirectlyReq> = {}) {
    return http.commonRequest<Model.CreateFlowByTemplateDirectlyRsq>({
        method: 'post',
        url: '/Tencent/CreateFlowByTemplateDirectly',
        data: config.data,
    }, 'CreateFlowByTemplateDirectly')
}

/**
 * 按用户 ID 和机构 ID 创建腾讯电子签业务信息
 */
export function requestInitTencentESS(config: RequestConfig<Model.InitTencentESSReq> = {}) {
    return http.commonRequest({
        method: 'post',
        url: '/Tencent/InitTencentESS',
        data: {
            userId: getUserId(),
            memberUserId: getMemberUserId(),
            ...config.data
        },
    })
}

/**
 * 按用户 ID 和机构 ID 创建机构交易协议申请信息
 */
export function requestInitMdUserSwapProtocol(config: RequestConfig<Model.InitMdUserSwapProtocolReq> = {}) {
    return http.commonRequest<Model.InitMdUserSwapProtocolRsp>({
        method: 'post',
        url: '/Tencent/InitMdUserSwapProtocol',
        data: {
            userId: getUserId(),
            memberUserId: getMemberUserId(),
            ...config.data
        },
    })
}

/**
 * 银行卡四要素认证
 */
export function requestBankCard4(config: RequestConfig<Model.BankCard4Req> = {}) {
    return http.commonRequest<Model.BankCard4Rsp>({
        method: 'post',
        url: '/Asign/BankCard4',
        data: config.data,
    })
}

/**
 * 重新发送认证验证码
 * 在实名认证的过程中，因用户手机原因未收到短信验证码或原验证码超过15分钟有效期而过期时，可以调用此接口重新发送短信验证码。若1分钟内多次调用此接口，则仅会发送一次短信验证码，15分钟内重新发送短信验证码不会变化。
 */
export function requestCaptcaResend(config: RequestConfig<Model.CaptcaResendReq> = {}) {
    return http.commonRequest<string>({
        method: 'post',
        url: '/Asign/CaptcaResend',
        data: config.data,
    })
}

/**
 * 认证验证码校验
 * 验证码认证成功后会调用爱签添加用户接口，同时调用交易系统JAVA实名认证接口
 */
export function requestCaptchaVerify(config: RequestConfig<Model.CaptchaVerifyReq> = {}) {
    return http.commonRequest<string>({
        method: 'post',
        url: '/Asign/CaptchaVerify',
        data: config.data,
    })
}

/**
 * 查询用户电子签记录表-爱签
 */
export function queryUsereSignRecords(config: RequestConfig<Model.UsereSignRecordsReq> = {}) {
    return http.commonRequest<Model.UsereSignRecordsRsq[]>({
        method: 'get',
        url: '/Asign/QueryUsereSignRecords',
        params: config.data,
    }, 'QueryUsereSignRecords')
}

/**
 * 爱签创建合同
 */
export function requestCreateContract(config: RequestConfig<Model.CreateContractReq> = {}) {
    return http.commonRequest<Model.CreateContractRsq>({
        method: 'post',
        url: '/Asign/CreateContract',
        data: config.data,
    }, 'CreateContract')
}

/**
 * 获取网上开户配置
 */
export function getWskhOpenAccountConfigs(config: RequestConfig<Model.WskhOpenAccountConfigsReq> = {}) {
    return http.commonRequest<Model.WskhOpenAccountConfigsRsp[]>({
        method: 'get',
        url: '/Common/GetWskhOpenAccountConfigs',
        params: config.data,
    }, 'GetWskhOpenAccountConfigs')
}